goog.provide("shadow.js.shim.module$$mui$material$AvatarGroup$default");
shadow.js.shim.module$$mui$material$AvatarGroup$default = shadow.js.shim.module$$mui$material$AvatarGroup.default;
